import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogOverlay,
	DialogPortal,
	DialogTitle,
} from "@/components/ui/dialog/dialog";
import CloseIcon from "@/components/ui/icon/cross";

type Props = {
	src: string;
	alt: string;
	open: boolean;
	onOpenChange: (open: boolean) => void;
};

export const ImageModal = ({ src, alt, open, onOpenChange }: Props) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogPortal>
				<DialogOverlay className="bg-black/80 z-[101]" />
				<DialogContent
					className="max-h-[90vh] max-w-[90vw] border-none bg-transparent p-0 shadow-none"
					hideCloseButton
				>
					<DialogTitle className="sr-only">{alt || "画像プレビュー"}</DialogTitle>
					<DialogClose className="absolute right-4 top-4 z-10 rounded-full bg-zinc-900/80 p-2 text-white transition-colors hover:bg-zinc-800">
						<CloseIcon className="h-5 w-5" />
						<span className="sr-only">閉じる</span>
					</DialogClose>
					<img src={src} alt={alt} className="max-h-[90vh] max-w-[90vw] rounded-lg object-contain" />
				</DialogContent>
			</DialogPortal>
		</Dialog>
	);
};
